import './ExpertInterest.sass'
import React, { useEffect, useState } from 'react'
import SidePanel from '@root/Auth/Views/SidePanel'
import Logo from '@root/Auth/Views/SidePanel/logo.js'
import Loading from '@components/spinner'
import NotFoundPage from '@components/NotFound/NotFoundPage'
import { massProcessingApi } from '@atheneum/api';

const ExpertInterest = (props) => {
  const { match } = props
  // Route: /expert/interest/:interested/:actionId
  const { interested, actionId } = match.params;

  const [ state, setState ] = useState({loading: true});

  const updateAction = async(emailActionId, interested) => {
    try {
      await massProcessingApi.updateActionInterest({emailActionId, interested});
    } catch (error) {
      console.error(error);
    } finally {
      setState({
        ...state,
        loading: false
      });
    }
  }

  useEffect(() => {
    updateAction(actionId, interested);
    // eslint-disable-next-line
  }, [])

  // If interested params not presented, show 404
  if(!interested || !actionId) {
    return <NotFoundPage />;
  }

  if(state.loading) {
    return <Loading />;
  }

  const parsedInterested = JSON.parse(interested);

  return (
    <div className="expert-compliance">
        <SidePanel />
        <div
          className="form-expert-compliance"
          style={{ display: 'flex', alignItems: 'center' }}>
          <Logo className="expert-compliance-form-logo" />
          <div
            className="form-inner"
            style={{
              maxWidth: '530px',
              borderColor: '#dfdfdf',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end'
            }}>
            <div className="unsubscribe-box">
              <h1 className="expert-form-login__title">Thanks for letting us know</h1>
              {/* if parsedInterested is true, then expert is interested */}
              {
                parsedInterested ?
                <div>
                  We will be in touch
                </div> :
                <div>
                  Have a nice day
                </div>
              }
            </div>
          </div>
        </div>
      </div>
  )
}

export default ExpertInterest;
